import { authSaga } from './auth/sagas';
import { userSaga } from './user/sagas';
import { employeeSaga } from './employee/sagas';
import { dealsSaga } from './deals/sagas';
import { loginsSaga } from './logins/sagas';
import { formsSaga } from './forms/sagas';
import { formPacksSaga } from './formPacks/sagas';
import { pencilsSaga } from './pencils/sagas';
import { deskingSaga } from './desking/sagas';
import { penSaga } from './pen/sagas';
import { sourceMappingsSaga } from './sourceMappings/sagas';
import { dealersSaga } from './dealers/sagas';
import { feedsSaga } from './feeds/sagas';
import { feedMappingsSaga } from './feedMappings/sagas';
import { rolesSaga } from './roles/sagas';
import { announcementsSaga } from './announcements/sagas';
import { permissionsSaga } from './permissions/sagas';
import { widgetsSaga } from './widgets/sagas';
import { verificationsSaga } from './verifications/sagas';
import { analyticsSaga } from './analytics/sagas';
import { dealerDataRevisionsSaga } from './dealerDataRevisions/sagas';
import { carsSaga } from './cars/sagas';
import { translationsSaga } from './translations/sagas';
import { translationRulesSaga } from './translationRules/sagas';
import { accessoryConfigSaga } from './accessories/sagas';
import { groupsSaga } from './groups/sagas';
import { websitesSaga } from './websites/sagas';
import { fontsSaga } from './fonts/sagas';
import { feedviewsSaga } from './feedviews/sagas';
import { outreachFormsSaga } from './outreachForms/sagas';
import { appConfigurationsSaga } from './appConfigurations/sagas';
import { dtEntitiesSaga } from './dtEntities/sagas';
import { tekionEntitiesSaga } from './tekionEntities/sagas';
import { pencilHistorySaga } from './pencilHistory/sagas';

export default [
  authSaga,
  userSaga,
  employeeSaga,
  dealsSaga,
  formsSaga,
  formPacksSaga,
  pencilsSaga,
  deskingSaga,
  penSaga,
  sourceMappingsSaga,
  dealersSaga,
  feedsSaga,
  feedMappingsSaga,
  rolesSaga,
  loginsSaga,
  announcementsSaga,
  permissionsSaga,
  widgetsSaga,
  verificationsSaga,
  analyticsSaga,
  dealerDataRevisionsSaga,
  carsSaga,
  translationsSaga,
  translationRulesSaga,
  accessoryConfigSaga,
  groupsSaga,
  websitesSaga,
  fontsSaga,
  feedviewsSaga,
  outreachFormsSaga,
  appConfigurationsSaga,
  dtEntitiesSaga,
  tekionEntitiesSaga,
  pencilHistorySaga,
];
